import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePageStudent from '../pages/Student/HomePageStudent';
import LoginPageStudent from '../pages/Auth/LoginPageStudent';
import StudentProtectedRoute from '../routes/Protected/student/StudentProtectedRoute';

export default function StudentRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="login" element={<LoginPageStudent />} />
      
      {/* Protected Routes */}
      <Route path="/" element={<StudentProtectedRoute><HomePageStudent /></StudentProtectedRoute>} />
      
      {/* Catch all - redirect to main student page */}
      <Route path="*" element={<Navigate to="/student" replace />} />
    </Routes>
  );
}